import { IApiGetUserResponseBody } from '~/lib/api/modules/Users';

export type IParsedUserInfo = {
  _id: string;
  initials?: string;
  username?: string;
  fullName?: string;
  emailAddress?: string;
  avatarUrl?: string;
};

export const parseUserInfo = (
  user: IApiGetUserResponseBody,
): IParsedUserInfo => {
  const firstName = user.profile?.firstname;
  const lastName = user.profile?.lastname;
  const username = user.profile?.username;
  const avatarUrl = user.profile?.avatar;
  const emailAddress = user.emails?.[0]?.address ?? user.profile?.email;
  const initials =
    !!firstName || !!lastName
      ? `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`
      : (username?.[0] ?? emailAddress?.[0]);
  const fullName =
    !!firstName || !!lastName
      ? `${firstName}${lastName ? ` ${lastName}` : ''}`
      : username;

  return {
    _id: user._id,
    initials,
    username,
    fullName,
    emailAddress,
    avatarUrl,
  };
};
